import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "fw-bold mb-3" };
const _hoisted_2 = { class: "bg-white p-3 mb-4" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-lg-6 col-12" };
const _hoisted_5 = { class: "form-check mb-3" };
const _hoisted_6 = { class: "form-floating mb-3" };
const _hoisted_7 = { class: "form-floating mb-3" };
const _hoisted_8 = { class: "form-floating mb-3" };
const _hoisted_9 = { class: "form-floating mb-3" };
const _hoisted_10 = ["value"];
const _hoisted_11 = { class: "form-floating mb-3" };
const _hoisted_12 = ["value"];
const _hoisted_13 = { class: "form-floating mb-3" };
const _hoisted_14 = { class: "form-floating mb-3" };
const _hoisted_15 = { class: "col-lg-6 col-12" };
const _hoisted_16 = { class: "form-floating mb-3" };
const _hoisted_17 = { class: "form-floating mb-3" };
const _hoisted_18 = {
    key: 0,
    class: "fw-bold text-danger"
};
const _hoisted_19 = { class: "form-check mb-3" };
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { onMounted } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        user: Object,
        languages: Object,
        roles: Object
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const confirm = useConfirm();
        const editUserForm = useForm({
            firstname: props.user ? props.user.firstname : null,
            lastname: props.user ? props.user.lastname : null,
            email: props.user ? props.user.email : null,
            offerEmail: props.user ? props.user.offerEmail : null,
            phone: props.user ? props.user.phone : null,
            lang: props.user ? props.user.lang : 'de',
            role: props.user ? props.user.role : null,
            active: props.user ? props.user.active : true,
        });
        const editPasswordForm = useForm({
            password: null,
            confirmPassword: null,
            notifyUser: true,
        });
        onMounted(() => {
        });
        function updateUser() {
            editUserForm.transform((data) => ({
                firstname: data.firstname,
                lastname: data.lastname,
                email: data.email,
                offerEmail: data.offerEmail,
                phone: data.phone,
                lang: data.lang,
                role: data.role,
                active: data.active,
            })).submit('put', route('admin.users.update', props.user.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updatePassword() {
            editPasswordForm.transform((data) => ({
                password: data.password,
                notify_user: data.notifyUser,
            })).submit('put', route('admin.users.updatePassword', props.user.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeUser() {
            confirm.require({
                message: 'Soll der Benutzer wirklich gelöscht werden?',
                header: 'Benutzer löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.users.destroy', props.user.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Benutzer-Details" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, "Benutzer: " + _toDisplayString(props.user.firstname) + " " + _toDisplayString(props.user.lastname), 1),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("form", {
                                        onSubmit: _withModifiers(updateUser, ["prevent"])
                                    }, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "active",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editUserForm).active) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(editUserForm).active]
                                            ]),
                                            _cache[11] || (_cache[11] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "active"
                                            }, "Aktiv?", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "firstname",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editUserForm).firstname) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editUserForm).firstname]
                                            ]),
                                            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "firstname" }, "Vorname", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "lastname",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editUserForm).lastname) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editUserForm).lastname]
                                            ]),
                                            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "lastname" }, "Nachname", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_8, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "email",
                                                class: "form-control",
                                                id: "email",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editUserForm).email) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editUserForm).email]
                                            ]),
                                            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "email" }, "E-Mail", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "role",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editUserForm).role) = $event)),
                                                required: ""
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.roles, (role) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: role.name
                                                    }, _toDisplayString(role.name), 9, _hoisted_10));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(editUserForm).role]
                                            ]),
                                            _cache[15] || (_cache[15] = _createElementVNode("label", { for: "role" }, "Benutzerrolle", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "lang",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editUserForm).lang) = $event)),
                                                required: ""
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.languages, (language) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: language.code
                                                    }, _toDisplayString(language.name), 9, _hoisted_12));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(editUserForm).lang]
                                            ]),
                                            _cache[16] || (_cache[16] = _createElementVNode("label", { for: "lang" }, "Sprache", -1))
                                        ]),
                                        _cache[19] || (_cache[19] = _createElementVNode("h5", { class: "fw-bold text-primary mb-3" }, "Kontakt-Details für Angebote", -1)),
                                        _cache[20] || (_cache[20] = _createElementVNode("p", null, "Nur Nutzer mit Angebots-E-Mail und Telefonnummer können als Ansprechpartner für Angebote ausgewählt werden.", -1)),
                                        _createElementVNode("div", _hoisted_13, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "email",
                                                class: "form-control",
                                                id: "offerEmail",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(editUserForm).offerEmail) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editUserForm).offerEmail]
                                            ]),
                                            _cache[17] || (_cache[17] = _createElementVNode("label", { for: "offerEmail" }, "E-Mail für Angebote", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "phone",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(editUserForm).phone) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editUserForm).phone]
                                            ]),
                                            _cache[18] || (_cache[18] = _createElementVNode("label", { for: "phone" }, "Telefonnummer", -1))
                                        ]),
                                        _cache[21] || (_cache[21] = _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ], -1))
                                    ], 32),
                                    _createElementVNode("button", {
                                        class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                        onClick: removeUser
                                    }, [...(_cache[22] || (_cache[22] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-x-circle",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                            ], -1),
                                            _createElementVNode("span", { class: "ms-2" }, "Benutzer löschen", -1)
                                        ]))])
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _cache[28] || (_cache[28] = _createElementVNode("h5", { class: "fw-bold text-primary mb-3" }, "Neue Zugangsdaten erstellen", -1)),
                                    _createElementVNode("form", {
                                        onSubmit: _withModifiers(updatePassword, ["prevent"])
                                    }, [
                                        _cache[26] || (_cache[26] = _createElementVNode("p", null, "Wenn kein Passwort angegeben wird, wird ein zufälliges Passwort generiert.", -1)),
                                        _createElementVNode("div", _hoisted_16, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "password",
                                                class: "form-control",
                                                id: "password",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(editPasswordForm).password) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editPasswordForm).password]
                                            ]),
                                            _cache[23] || (_cache[23] = _createElementVNode("label", { for: "password" }, "Passwort", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_17, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "password",
                                                class: "form-control",
                                                id: "confirmPassword",
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(editPasswordForm).confirmPassword) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editPasswordForm).confirmPassword]
                                            ]),
                                            _cache[24] || (_cache[24] = _createElementVNode("label", { for: "confirmPassword" }, "Passwort wiederholen", -1))
                                        ]),
                                        (_unref(editPasswordForm).password != _unref(editPasswordForm).confirmPassword)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Die Passwörter stimmen nicht überein."))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_19, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "notifyUser",
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(editPasswordForm).notifyUser) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(editPasswordForm).notifyUser]
                                            ]),
                                            _cache[25] || (_cache[25] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "notifyUser"
                                            }, "Nutzer über neuen Zugangsdaten benachrichtigen?", -1))
                                        ]),
                                        _cache[27] || (_cache[27] = _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ], -1))
                                    ], 32)
                                ])
                            ])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
